import { useState } from "react"
import styled from "styled-components"

import CustomSimulationInformation from "../shared/CustomSimulationInformation"
import CustomSimulator from "../shared/CustomSimulator"
import DepositHere from "../shared/DepositHere"
import SimulationStopOutText from "./SimulationStopOutText"
import { heroOptions } from "../helpers/heroOptions"
import CustomHero from "../ui/CustomHero"
import Footer from "../ui/Footer"

const DepositContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
`

const StopOutCalculator = () => {
  const [formState, setFormState] = useState<FormValues>({
    equity: "",
    usedMargin: "",
  })
  const [showSimulationInformation, setShowSimulationInformation] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [hasErrors, setHasErrors] = useState<boolean>(false)
  const title = "Simular niveles de StopOut"
  const subText = `Simula el punto de StopOut, viendo cuánto más tendrías que perder
  para irte en StopOut.`
  const buttonText = "Simular Nivel de StopOut"
  const knowMoreUrl = "https://url-video-pendiente.com"
  const depositText = "¿Cercano a StopOut?"
  return (
    <>
      <CustomHero
        heroTitle={heroOptions().heroTitle}
        text={heroOptions().heroText}
        img={heroOptions().heroImg()}
      />
      <CustomSimulator
        title={title}
        subText={subText}
        buttonText={buttonText}
        knowMoreUrl={knowMoreUrl}
        formState={formState}
        setFormState={setFormState}
        setShowSimulationInformation={setShowSimulationInformation}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
        hasErrors={hasErrors}
        setHasErrors={setHasErrors}
      />
      <CustomSimulationInformation
        showSimulationInformation={showSimulationInformation}
        formState={formState}
        hasErrors={hasErrors}
      >
        <SimulationStopOutText formState={formState} />
      </CustomSimulationInformation>
      <DepositContainer>
        <DepositHere text={depositText} />
      </DepositContainer>
      <Footer />
    </>
  )
}

export default StopOutCalculator
